import { render, staticRenderFns } from "./TbPaketanTertutup.vue?vue&type=template&id=2fb54364"
import script from "./TbPaketanTertutup.vue?vue&type=script&lang=js"
export * from "./TbPaketanTertutup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports